<template>
    <div>
        <b-row>
            <b-col cols="12" lg="1">
                <b-icon :icon="icon" scale="1.5" class="d-none d-lg-block ml-lg-4"></b-icon>
            </b-col>
            <b-col cols="12" lg="2">
                <div class="text-dark pt-lg-1">
                    {{ model.updatedDate | moment("DD-MMM-YYYY HH:mm") }}
                </div>
            </b-col>
            <b-col cols="12" lg="3">
                <div>
                    <h4 class="font-weight-bold mb-0 mb-lg-1">
                        {{ model.approvalTag }}
                    </h4>
                </div>
            </b-col>
            <b-col cols="12" lg="2">
                <div class="text-secondary pt-lg-1">
                    {{ model.approvalType != null ? model.approvalType.name : '' }}
                </div>
            </b-col>
            <b-col cols="12" lg="2">
                <b-badge :variant="badgeVariant" class="mt-lg-2">
                    {{ model.status }}
                </b-badge>
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    props: ["model","documentId", "approvalStatus"],
    data() {
        return {
            datas: [],
            entityRoute: '',
            statusRoute: '',
        }
    },
    methods : {
        
    },
    mounted() {
        
    },
    computed: {
        badgeVariant() {
            if (this.model.status == 'REQUEST FOR REVISION') {
                return 'warning';
            }
            return 'primary';
        },
        icon() {
            if (this.model.approvalType != null) {
                if (this.model.approvalType.name != null) {
                    if (this.model.approvalType.name.toLowerCase() == 'survey request form') {
                        return 'file-bar-graph';
                    }
                }
            }
            return 'file-check';
        }
    }
}
</script>